import { DisposalSet, select } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

import Splide from '@splidejs/splide';

const gc = new DisposalSet();

interface ayCardListConfiguration {
    enableSliderAtBreakpoint: string;
}

registerFragment<ayCardListConfiguration>('ay-card-list', (fragEl, config, meta) => {
    const sliderBreakpoint = config.enableSliderAtBreakpoint || 'none';

    if(!document.body.classList.contains('has-edit-mode-menu') && sliderBreakpoint !== 'none') {
        const sliderBreakpointNum: number = sliderBreakpoint === 'always' ? 9999 : (Number(sliderBreakpoint) || 0);

        const sliderEl = select<HTMLDivElement>(fragEl, '.splide.ay-card-slider__slider-container');

        const isRTL = document.documentElement.classList.contains('rtl');
        const pageDirection = isRTL ? 'rtl' : 'ltr';

        const splide = new Splide(sliderEl, {
            type: 'slide',
            gap: 24,
            pagination: false,
            fixedWidth: 'fit-content',
            perMove: 1,
            live: false,
            speed: 600,
            direction: pageDirection,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: false,
            mediaQuery: 'min',
            autoWidth: true,
            // focus: 0,
            // trimSpace: 'move',
            omitEnd: true,
            rewind: true,
            breakpoints: {
                [sliderBreakpointNum]: {
                    destroy: true,
                },
            }
            // breakpoints: {
            //     1000: {
            //         gap: 24,
            //         perMove: 2
            //     },
            //     768: {
            //         perMove: 1
            //     },
            // }
        });

        /**
         * Custom Wheel Handler: Shift + Scroll
         */
        let targetPosition: number | null = null;
        let scrollTimeout: any;

        const handleShiftScroll = (e: WheelEvent) => {
            if (e.shiftKey) {
                const delta = e.deltaX !== 0 ? e.deltaX : e.deltaY;
                if (delta === 0) return;

                e.preventDefault();

                const { Move, Scroll } = (splide as any).Components;

                // Detect hardware: Trackpads emit small/fractional deltas, mouse wheels emit large notches (>=50)
                const isTrackpad = Math.abs(delta) < 50 || !Number.isInteger(delta);

                if (isTrackpad) {
                    // TRACKPAD MODE: Mimic Native Click-and-Drag
                    const currentPosition = Move.getPosition();
                    const sensitivity = 2.0; // 1:1 physical tracking with your fingers
                    let nextPosition = currentPosition - (delta * sensitivity);

                    const startLimit = Move.getLimit(false);
                    const endLimit = Move.getLimit(true);
                    nextPosition = Math.max(Math.min(nextPosition, startLimit), endLimit);

                    // Kill any running inertial animations so they don't fight the trackpad
                    Scroll.cancel();

                    // Instantly translate the DOM element (exactly what dragging does mid-swipe)
                    Move.translate(nextPosition);

                    // Splide needs to update its active index state, but doing it on every frame
                    // causes lag. We debounce it to run once the user pauses swiping.
                    clearTimeout(scrollTimeout);
                    scrollTimeout = setTimeout(() => {
                        Scroll.scroll(nextPosition, 0, false);
                        targetPosition = null;
                    }, 150);

                } else {
                    // MOUSE WHEEL MODE: Maintain the premium inertia glide
                    let currentTarget = targetPosition !== null ? targetPosition : Move.getPosition();

                    const sensitivity = 3.0; // Punchy distance per mouse wheel notch
                    currentTarget -= (delta * sensitivity);

                    const startLimit = Move.getLimit(false);
                    const endLimit = Move.getLimit(true);
                    const nextPosition = Math.max(Math.min(currentTarget, startLimit), endLimit);

                    targetPosition = nextPosition;
                    Scroll.scroll(nextPosition, 200, false); // 200ms bridges the physical wheel clicks

                    clearTimeout(scrollTimeout);
                    scrollTimeout = setTimeout(() => {
                        targetPosition = null;
                    }, 500);
                }
            }
        }

        splide.mount();
        sliderEl.addEventListener('wheel', handleShiftScroll, { passive: false });

        gc.register(() => {
            clearTimeout(scrollTimeout);
            sliderEl.removeEventListener('wheel', handleShiftScroll);
            splide.destroy();
        });
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
